import { PERMISSIONS } from '@tempo-io/permissions';
import { defineNotificationCategory } from './types';

export const trialsDescriptor = defineNotificationCategory('trials', {
  actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/subscriptions`,
  pills: () => ['Trial'],
  audience: PERMISSIONS.EDIT_BILLING,
  scope: 'account',
  defaultChannels: ['in_app'],
});

export const trialExtendedDescriptor = defineNotificationCategory('trial_extended', {
  actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/subscriptions`,
  pills: () => ['Trial'],
  audience: PERMISSIONS.EDIT_BILLING,
  scope: 'account',
  defaultChannels: ['in_app'],
});

export const capacityOrphanedInstanceDescriptor = defineNotificationCategory(
  'capacity_orphaned_instance',
  {
    actionUrl: (_data, organizationId) =>
      `/org-id/${organizationId}/settings/capacity/orphaned-data`,
    pills: (data) => (data.instanceName ? [data.instanceName, 'Capacity'] : ['Capacity']),
    audience: PERMISSIONS.EDIT_CAPACITY,
    scope: 'account',
    defaultChannels: ['email', 'in_app', 'slack'],
  },
);
